import heroSlides from "../Data/heroSlides";

export default function useHeroSlides() {
    // future-proof: sorting, filtering, AB testing, API fetch
    const slides = heroSlides.map((slide, index) => ({
        ...slide,
        id: index,
        priority: index === 0, // auto-priority first slide
    }));

    return slides;
}
